/** Organization roles a membership (or invitation) can carry. Mirrors the backend `OrgRole`. */
export const ORG_ROLES = [
  {
    value: "admin",
    label: "Admin",
    description: "Manage members, groups and organization settings.",
  },
  {
    value: "member",
    label: "Member",
    description: "Access the organization's tenants and collections.",
  },
  {
    value: "crm_reader",
    label: "CRM reader",
    description: "Read CRM data via Vayken CRM (reporting on calls, email, LinkedIn and funnels).",
  },
] as const;

export type OrgRole = (typeof ORG_ROLES)[number]["value"];

export function orgRoleLabel(role: string): string {
  return ORG_ROLES.find((r) => r.value === role)?.label ?? role;
}
